export const START_LOADING = 'loading/START_LOADING'
export const FINISH_LOADING = 'loading/FINISH_LOADING'
